/* unplugin-vue-components disabled */import { render } from "./rotateCover.vue?vue&type=template&id=432eeee2&ts=true"
import script from "./rotateCover.vue?vue&type=script&lang=ts&setup=true"
export * from "./rotateCover.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/baseui/player/rotateCover.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "432eeee2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('432eeee2', __exports__)) {
    console.log('reload')
    api.reload('432eeee2', __exports__)
  }
  
  module.hot.accept("./rotateCover.vue?vue&type=template&id=432eeee2&ts=true", () => {
    console.log('re-render')
    api.rerender('432eeee2', render)
  })

}


export default __exports__